const ip = window.location.hostname;
const protocol = window.location.protocol === "https:" ? "https" : "http";

export const IMAGE_URL =
  protocol == "http"
    ? `${protocol}://${ip}:${process.env.REACT_APP_BACKEND_PORT}/images/`
    : `${protocol}://${ip}/images/`;

export const API_URL =
  protocol == "http"
    ? `${protocol}://${ip}:${process.env.REACT_APP_BACKEND_PORT}/api/`
    : `${protocol}://${ip}/api/`;

export const BASE_URL =
  protocol == "http"
    ? `${protocol}://${ip}:${process.env.REACT_APP_BACKEND_PORT}/`
    : `${protocol}://${ip}/`;

export const priceunit = "DZD ";
